import React from "react";
import "./DrSection.css";
import doctorImg from "../../assets/dr.jpeg"; // add your image
import     { Link } from "react-router-dom";
const DoctorSection = () => {
  return (
    <section className="doctor-section">
      <div className="container doctor-wrapper">

        {/* IMAGE */}
        <div className="doctor-image">
          <img src={doctorImg} alt="Dr Harjeet Kaur" />
        </div>

        {/* CONTENT */}
        <div className="doctor-contentt">

          <span className="gynae-tag">Meet Our Expert</span>

          <h2>Dr. Harjeet Kaur</h2>

          <p className="doctor-role">
            Founder, Medical Director & Chief Embryologist
          </p>

          <p className="doctor-desc">
            With over 12+ years of experience in IVF and embryology,
            Dr. Harjeet Kaur has successfully handled 10,000+ cases.
            She is known for her ethical approach, precision, and
            compassionate patient care, ensuring every couple feels
            supported throughout their fertility journey.
          </p>

          <div className="doctor-stats">
            <div>
              <h3>12+</h3>
              <p>Years Experience</p>
            </div>
            <div>
              <h3>10,000+</h3>
              <p>Successful Cases</p>
            </div>
          </div>

          {/* <button className="doctor-btn">Book Consultation</button> */}
            <Link to="/bookappointment" className='about-btn'>Book Consultation</Link>
        </div>

      </div>
    </section>
  );
};

export default DoctorSection;